import routes from './routes';
import { SetRoutes } from 'components';

const AllReports = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default AllReports;
